import React from 'react';
import './LoadingSpinner.css';
import RingLoader from "react-spinners/RingLoader";

const LoadingSpinner = () => {
    return (
        <div className="spinner-container">
            <div className="loading-spinner-post">
             <RingLoader/>
            </div>
        </div>
    );
    }
    ;

export default LoadingSpinner;
